// const API_URL = "http://localhost:5000";
const API_URL = "https://mern-chat-app-backend-4omg.onrender.com";

const BASE_APP_URL = "http://localhost:3000/";

export { API_URL, BASE_APP_URL };
